"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
export default function () {
  const milestones = [{
    year: "2024",
    titleBefore: "The idea .. ",
    titleAccent: "close the skill gap ",
    titleAfter: " & share value",
    body: "ESO founder, Mark Chapman, was was offering volunary consultancy to a small charity to redfine it makreting strategy. One of the main goals was to reach new audiences, and Mark identified an opportunity for university students to participate in very structured marketing roles as work experience - as long as the placements were not a drain on the busy members of staff trying to cover several positions. Hence the concept of having a shared value contract between the charity and the student was born. Mark then did more informal research and found that the concept resonated with charities and Higher Education bodies, as well as a few MPs. "
  }, {
    year: "2025",
    titleBefore: "Testing ",
    titleAccent: "the concept",
    titleAfter: " in Reality",
    body: "In May 2025, Mark was priveleged to become a Trustee for the Flavel (Trust) Arts Centre in Dartmouth, Devon. The Board of Trustees and the General Manager agreed to test the concept by creating Digital Marketing and ESG/Sustainability briefs. Both placements were beneficial to both the Flavel and the young people giving their time - see the case studies section."
  }, {
    year: "2026",
    titleBefore: "Launching ",
    titleAccent: "Elevate Social Outcomes",
    titleAfter: " framework",
    body: "The goal is to move beyond the pilot phase creating more positve outmomes for both employability and social impact. The ESO concept is a repeatable shared value model. By focusing on Skills, Development, and Affinity to causes; to connect more charities with the emerging talent they need to thrive in a digital-first world."
  }, {
    year: "2030",
    titleBefore: "Deliver  ",
    titleAccent: "100 outcomes",
    titleAfter: " from placements",
    body: "The vsion is to give 100 young peole work experince to find their Dream Job ... and 100 charities the expertise they need to deliver greater social impact"
  }];
  return;
}
function TimelineHeader() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <div ref={ref} className="mx-auto max-w-[760px] text-center" style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(16px)",
    transition: "opacity 700ms cubic-bezier(0.22, 1, 0.36, 1), transform 700ms cubic-bezier(0.22, 1, 0.36, 1)"
  }}>
      <div className="mb-8 flex justify-center">
        <div className="inline-block rounded-lg bg-white p-3 shadow-md">
          <WvcLogo className="h-12 w-auto" />
        </div>
      </div>

      <h2 className="mt-6 font-default text-slate-900" style={{
      fontSize: "clamp(2rem, 4vw, 3.5rem)",
      fontWeight: 400,
      letterSpacing: "-0.02em",
      lineHeight: 1.06
    }}>
        {"Turning gaps into "}
        <em className="not-italic" style={{
        fontFamily: "var(--font-serif)",
        fontStyle: "italic",
        fontWeight: 400,
        color: "hsl(142 71% 45%)",
        fontSize: "1.08em"
      }}>
          outcomes
        </em>
      </h2>

      
    </div>;
}
type MilestoneProps = {
  index: number;
  year: string;
  titleBefore: string;
  titleAccent: string;
  titleAfter: string;
  body: string;
  isLast: boolean;
};
function Milestone({
  index,
  year,
  titleBefore,
  titleAccent,
  titleAfter,
  body,
  isLast
}: MilestoneProps) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <div ref={ref} data-index={index} className={isLast ? "" : "mb-20 border-b border-slate-200 pb-20 md:mb-20 md:pb-20"} style={{
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0)" : "translateY(16px)",
    transition: `opacity 700ms cubic-bezier(0.22, 1, 0.36, 1) ${index * 80}ms, transform 700ms cubic-bezier(0.22, 1, 0.36, 1) ${index * 80}ms`
  }}>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-12 md:gap-6">
        <div className="md:col-span-4">
          <span className="block font-default text-slate-900" style={{
          fontSize: "clamp(2rem, 3vw, 2.75rem)",
          fontWeight: 300,
          letterSpacing: "-0.02em",
          lineHeight: 1,
          fontFeatureSettings: '"tnum"'
        }}>
            {year}
          </span>
        </div>

        <div className="relative md:col-span-8">
          <div aria-hidden="true" className="mb-6 h-px w-16 md:absolute md:left-0 md:top-2 md:mb-0 md:h-12 md:w-px" style={{
          backgroundColor: "hsl(199 89% 48%)"
        }} />

          <div className="md:pl-8">
            <h3 className="font-default text-slate-900" style={{
            fontSize: "clamp(1.5rem, 2.4vw, 2rem)",
            fontWeight: 500,
            letterSpacing: "-0.015em",
            lineHeight: 1.15
          }}>
              {titleBefore}
              <em className="not-italic" style={{
              fontFamily: "var(--font-serif)",
              fontStyle: "italic",
              fontWeight: 400,
              color: "hsl(199 89% 48%)",
              fontSize: "1.08em"
            }}>
                {titleAccent}
              </em>
              {titleAfter}
            </h3>

            
          </div>
        </div>
      </div>
    </div>;
}